<div class="booking-create-success">
  <div class="booking-create-success__body">
    <div class="booking-create-success__summary sf-section">
      @if (service && service.image && service.name) {
        <app-image
          class="booking-create-success__summary-image"
          [src]="service.image"
          [alt]="service.name"
          preset="card"
          aspectRatio="1"
          [sizes]="'380px'"
          [width]="380"
          [height]="380"
        ></app-image>
      }
      <div class="booking-create-success__summary-details">
        <div class="booking-create-success__summary-header">
          @if (service && service.name) {
            <h3>{{ service.name }}</h3>
          }
          <div class="tag tag--green">
            {{ ('bookings.status.' + billingInfo?.status) | transloco }}
          </div>
        </div>

        @if (billingInfo) {
          <div class="booking-create-success__summary-table">
            @if (billingInfo.publicPrice) {
              <div class="booking-create-success__summary-row">
                <span>{{ 'marketplace.booking.create.success.summary.amount' | transloco }}</span>
                <span>{{ billingInfo.publicPrice | currency:'EUR' }}</span>
              </div>
              @if (billingInfo.discount) {
                <div class="booking-create-success__summary-row">
                  <span>{{ 'service.pricing.discount' | transloco }}</span>
                  <span>-{{ billingInfo.discount | currency:'EUR' }}</span>
                </div>
              }
              @if (billingInfo.publicPrice !== null && billingInfo.publicPrice !== undefined) {
                <div class="booking-create-success__summary-row booking-create-success__summary-row--total">
                  <span>{{ 'marketplace.booking.create.success.summary.total' | transloco }}</span>
                  <strong>{{ (billingInfo.publicPrice - (billingInfo.discount ?? 0)) | currency:'EUR' }}</strong>
                </div>
              }
            } @else if (service && service.publicPrice) {
              <div class="booking-create-success__summary-row booking-create-success__summary-row--total">
                <span>{{ 'marketplace.booking.create.success.summary.total' | transloco }}</span>
                <strong>{{ (service.publicPrice) | currency:'EUR' }}</strong>
              </div>
            }
          </div>
        }

        @if (bookingId) {
          <button class="button button--primary button--full-width" [routerLink]="['/booking', bookingId]">
            {{ 'marketplace.booking.create.success.cta.label' | transloco}}
          </button>
        }
      </div>
    </div>

    <div class="booking-create-success__actions">
      <div class="booking-create-success__title">
        <h1>{{'marketplace.booking.create.success.title'|transloco}}</h1>
      </div>
      <p class="booking-create-success__subtitle">
        {{'marketplace.booking.create.success.subtitle'|transloco }}
      </p>

      <section class="booking-create-success__next sf-section">
        <h2 class="sf-section__title">{{ 'marketplace.booking.create.success.next.title' | transloco }}</h2>
        <p class="sf-section__subtitle">{{ 'marketplace.booking.create.success.next.subtitle' | transloco }}</p>
        <ol class="booking-create-success__steps">
          <li class="booking-create-success__step">
            <i class="fa-solid fa-paper-plane"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.success.next.steps.submitted.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.success.next.steps.submitted.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-success__step">
            <i class="fa-solid fa-calendar-check"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.success.next.steps.accepted.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.success.next.steps.accepted.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-success__step">
            <i class="fa-solid fa-camera-retro"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.success.next.steps.shooting.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.success.next.steps.shooting.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-success__step">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.success.next.steps.processing.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.success.next.steps.processing.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-success__step">
            <i class="fa-solid fa-image"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.success.next.steps.delivery.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.success.next.steps.delivery.text' | transloco }}</p>
            </div>
          </li>
        </ol>
      </section>

      @if (!isCustomer) {
        <div class="booking-create-success__create-account sf-section">
          <h2 class="sf-section__title">{{'marketplace.booking.create.success.create-account.title'|transloco}}</h2>
          <form [formGroup]="accountForm" (ngSubmit)="createAccount()" class="create-account-form">
            <div class="input-group--side-by-side">
              <div class="input-group">
                <label>{{'marketplace.booking.create.success.create-account.form.firstname.label'|transloco}}</label>
                <input type="text" formControlName="firstname" placeholder="{{'marketplace.booking.create.success.create-account.form.firstname.placeholder'|transloco}}" />
              </div>
              <div class="input-group">
                <label>{{'marketplace.booking.create.success.create-account.form.lastname.label'|transloco}}</label>
                <input type="text" formControlName="lastname" placeholder="{{'marketplace.booking.create.success.create-account.form.lastname.placeholder'|transloco}}" />
              </div>
            </div>
            <div class="input-group">
              <label>{{'marketplace.booking.create.success.create-account.form.email.label'|transloco}}</label>
              <input type="email" [value]="customerEmail" disabled />
            </div>
            <div class="input-group--side-by-side">
              <div class="input-group">
                <label>{{'marketplace.booking.create.success.create-account.form.password.label'|transloco}}</label>
                <input type="password" formControlName="password" placeholder="{{'marketplace.booking.create.success.create-account.form.password.placeholder'|transloco}}" />
              </div>
              <div class="input-group">
                <label>{{'marketplace.booking.create.success.create-account.form.password-confirm.label'|transloco}}</label>
                <input type="password" formControlName="passwordConfirm" placeholder="{{'marketplace.booking.create.success.create-account.form.password-confirm.placeholder'|transloco}}" />
              </div>
            </div>
            <div class="create-account-form__actions">
              <button class="button" type="submit" [disabled]="accountForm.invalid">
                {{'marketplace.booking.create.success.create-account.form.submit'|transloco}}
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </form>
        </div>
        <div class="booking-create-success__login sf-section">
          <div class="booking-create-success__login-content">
            <h2 class="sf-section__title">{{'marketplace.booking.create.success.login.title'|transloco}}</h2>
          </div>
          <button class="button" [routerLink]="['/login']">
            {{'marketplace.booking.create.success.login.cta.label'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      }

      @if (isCustomer) {
        <div class="booking-create-success__my-bookings sf-section">
          <div class="left">
            <h2 class="sf-section__title">{{'marketplace.booking.create.success.my-bookings.title'|transloco}}</h2>
            <p>{{'marketplace.booking.create.success.my-bookings.subtitle'|transloco}}</p>
          </div>
          <a class="button"
            [routerLink]="['/my-account']"
            >
            {{'marketplace.booking.create.success.my-bookings.label'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      }
    </div>
  </div>
</div>
